import { postManufacturingV1Data } from 'services/manufacturingV1';

export async function postDispatcherTrigger(supplierId, creates, updates) {
  let response = '';
  let errorMessage = '';
  try {
    response = await postManufacturingV1Data({
      url: `trigger?supplierId[in]=${supplierId}&creates=${creates}&updates=${updates}`,
      withAuth: true,
      data: {},
    })
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}
